import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

import { CONVERT_INVOICE_TO_RA_MUTATION } from '../constants';
import {
  ConvertInvoiceToRaMutationResponse,
  ConvertInvoiceToRaMutationVariables,
  UseConvertInvoiceToRaMutationProps,
} from '../types';

/**
 * Shared function to execute the convert invoice to RA mutation
 */
const useConvertInvoiceToRaBaseMutation = () => {
  const [convertMutation] = useMutation<
    ConvertInvoiceToRaMutationResponse,
    ConvertInvoiceToRaMutationVariables
  >(CONVERT_INVOICE_TO_RA_MUTATION);

  return useCallback(
    async (
      invoiceId: number,
      reportId?: number | string,
      quickCheckout?: boolean
    ): Promise<ConvertInvoiceToRaMutationResponse> => {
      return await convertMutation({
        variables: {
          invoiceId,
          quickCheckout,
        },
      }).then((response) => response.data);
    },
    [convertMutation]
  );
};

export const useConvertInvoiceToRaMutation = ({
  invoiceId,
  reportId,
}: UseConvertInvoiceToRaMutationProps) => {
  const executeConversion = useConvertInvoiceToRaBaseMutation();

  return useCallback(
    async (
      quickCheckout?: boolean
    ): Promise<ConvertInvoiceToRaMutationResponse> => {
      return executeConversion(invoiceId, reportId, quickCheckout);
    },
    [executeConversion, invoiceId, reportId]
  );
};

export const useConvertInvoiceToRa = () => {
  const executeConversion = useConvertInvoiceToRaBaseMutation();

  return useCallback(
    async (invoiceId: number): Promise<ConvertInvoiceToRaMutationResponse> => {
      return executeConversion(invoiceId);
    },
    [executeConversion]
  );
};
